import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Context from '../context';
import { Loader } from '../commonComponents';

import './login.scss';

// Todo: Refactor JSX into subcomponents
// Remove ternatory operators from JSX

const Login = (props) => {
  const context = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');

  useEffect(() => {
    const login = context.isAuth;
    if (login) {
      props.history.push('home');
    }
  }, []);

  const updateFormData = (event) =>
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });

  const { email, password } = formData;
  const submitForm = (e) => {
    e.preventDefault();

    if (email === 'Acuvue' && password === 'jnjmylook@634') {
      context.login(true);
      localStorage.setItem('loggedIn', 1);
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        props.history.push('');
      }, 1000);
    } else {
      setError('Invalid email and password');
      setTimeout(() => {
        setError('');
      }, 2000);
    }
  };
  return (
    <React.Fragment>
      {!loading ? (
        <div className="login-component">
          <div className="component-wrapper">
            <form className="login-form">
              <div className="form-item form-item--email">
                <label htmlFor="email">
                  <FormattedMessage id="login.email" defaultMessage="E-mail" />
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  required
                  name="email"
                  onChange={(e) => updateFormData(e)}
                  placeholder="Email address"
                  className="form-control text-medium"
                />
              </div>
              <div className="form-item form-item--password">
                <label htmlFor="password">
                  <FormattedMessage id="login.password" defaultMessage="Password" />
                </label>
                <input
                  id="password"
                  value={password}
                  name="password"
                  onChange={(e) => updateFormData(e)}
                  placeholder="Password"
                  type="password"
                  required
                  className="form-control text-medium"
                />
              </div>
              {error}
              <button
                onClick={submitForm}
                className="text-medium  btn btn-red btn-submit"
                type="submit"
              >
                <FormattedMessage id="login.submit" defaultMessage="Submit" />
              </button>
            </form>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </React.Fragment>
  );
};

export default withRouter(Login);
